import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiLogoIconinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 120 120",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "url(#b)",
			d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillOpacity: .94,
			d: "M55.712 29.957c1.5-3.943 7.077-3.943 8.578 0l4.173 10.957a18.36 18.36 0 0 0 10.624 10.624l10.957 4.173c3.943 1.5 3.943 7.077 0 8.578l-10.957 4.173a18.36 18.36 0 0 0-10.624 10.624L64.29 90.044c-1.5 3.941-7.077 3.941-8.578 0l-4.173-10.958a18.36 18.36 0 0 0-10.624-10.624l-10.957-4.173c-3.942-1.5-3.942-7.077 0-8.578l10.957-4.173a18.36 18.36 0 0 0 10.624-10.624z"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("radialGradient", {
		id: "b",
		cx: 0,
		cy: 0,
		r: 1,
		gradientTransform: "rotate(125.33 42.18 28.717)scale(99.7702)",
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#9884ff" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#471cff"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h120v120H0z"
		})
	})] })]
});
export default SvgAiLogoIconinline;
